import type { PctCount, UsageBlock } from '../../services/analytics';
import { DASH, formatInt, formatPct } from './format';

export type SegmentMetricId = 'dau' | 'wau' | 'mau' | 'ausentes';

export interface SegmentMetricView {
    id: SegmentMetricId;
    label: string;
    value: string;
    caption: string;
}

export interface SegmentView {
    id: 'pagantes' | 'gratuitasTrial';
    title: string;
    /** "Base 24 · 80% do total" */
    baseLabel: string;
    metrics: SegmentMetricView[];
}

const METRICS: Array<{ id: SegmentMetricId; label: string }> = [
    { id: 'dau', label: 'DAU' },
    { id: 'wau', label: 'WAU' },
    { id: 'mau', label: 'MAU' },
    { id: 'ausentes', label: 'Ausentes' },
];

/** "20,8% da base". Sem contas no recorte nao ha percentual. */
function baseCaption(c: PctCount): string {
    if (c.base <= 0 || c.pct === null) return 'Sem contas no recorte';
    return `${formatPct(c.pct)} da base`;
}

function baseLabel(block: UsageBlock, total: number): string {
    const base = `Base ${formatInt(block.base)}`;
    if (!(total > 0)) return base;
    return `${base} · ${formatPct((block.base / total) * 100)} do total`;
}

/** Card de um recorte (pagantes ou gratuitas), com os textos do prototipo. */
export function buildSegmentCard(
    id: SegmentView['id'],
    title: string,
    block: UsageBlock,
    total: number,
): SegmentView {
    return {
        id,
        title,
        baseLabel: baseLabel(block, total),
        metrics: METRICS.map(({ id: mid, label }) => ({
            id: mid,
            label,
            value: block[mid].base > 0 ? formatInt(block[mid].count) : DASH,
            caption: baseCaption(block[mid]),
        })),
    };
}

/** Os dois recortes, na ordem do prototipo. */
export function buildSegmentCards(u: {
    pagantes: UsageBlock;
    gratuitasTrial: UsageBlock;
    totalContas: number;
}): SegmentView[] {
    return [
        buildSegmentCard('pagantes', 'Assinantes pagos', u.pagantes, u.totalContas),
        buildSegmentCard('gratuitasTrial', 'Gratuitas', u.gratuitasTrial, u.totalContas),
    ];
}
